<template>
    <v-hover v-slot="{ hover }" open-delay="200" ref="hover">
        <div class="app-side-buttons menu-top-space" >
            <v-scale-transition>
                <div v-show="hover || permanent || showMenu" v-if="incident">
                    <inc-create-button
                        v-if       = "incident"
                        :site      = "incident.sites[0].id"
                        @opend     = "onSubmenuOpen"
                        class      = "mb-3"
                    />

                    <c-menu-button
                        label      = "inc.edit.menu.save"
                        icon       = "mdi-content-save-outline"
                        icon-color = "primary--text"
                        @click     = "onSave"
                    />

                    <c-menu-button
                        label      = "inc.edit.menu.email"
                        icon       = "mdi-email-outline"
                        icon-color = "primary--text"
                        @click     = "onMail"
                    />

                    <c-menu-button
                        v-if       = "!incident.refresh"
                        label      = "inc.edit.menu.reload"
                        icon       = "mdi-reload"
                        icon-color = "primary--text"
                        @click     = "onRefresh"
                    />

                    <c-menu-button
                        label      = "inc.edit.menu.history"
                        icon       = "mdi-history"
                        icon-color = "primary--text"
                        @click     = "onHistory"
                    />

                    <c-menu-button
                        v-if       = "isClipboardAllowed && !clipboardEntry"
                        label      = "clipboard.add.tooltip"
                        icon       = "mdi-clipboard-plus-outline"
                        icon-color = "primary--text"
                        @click     = "onClipboard"
                    />

                    <c-menu-button
                        v-if       = "isClipboardRemoveAllowed && clipboardEntry"
                        label      = "clipboard.remove.tooltip"
                        icon       = "mdi-clipboard-remove-outline"
                        icon-color = "error--text"
                        @click     = "onClipboarRemove"
                    />

                    <inc-print-button
                        v-if       = "incident"
                        @opend     = "onSubmenuOpen"
                        :incident  = "incident"
                        :index     = "index"
                        class      = "mb-3"
                    />

                    <inc-change-button
                        v-if       = "preferences['dataadmin'] &&  !incident.deleted && allowed.length > 0"
                        :incident  = incident
                        :allowed   = "allowed"
                        @opend     = "onSubmenuOpen"
                        @changed   = "onChanged"
                        class      = "mb-3"
                    />

                    <c-menu-button
                        v-if       = "preferences['dataadmin'] &&  !incident.deleted"
                        label      = "inc.delete.tooltip"
                        icon       = "mdi-delete-outline"
                        icon-color = "red--text"
                        @click     = "onDelete"
                    />

                    <c-menu-button
                        v-if       = "preferences['dataadmin'] &&  incident.deleted"
                        label      = "inc.undelete.tooltip"
                        icon       = "mdi-undo"
                        icon-color = "primary--text"
                        @click     = "onUnDelete"
                    />
                </div>
            </v-scale-transition>
        </div>
    </v-hover>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import CMenuButton     from "@/modules/core/components/utils/CMenuButton.vue";
import IncCreateButton from "@/modules/inc/steps/components/common/menu/private/IncCreateButton.vue";
import IncChangeButton from "@/modules/inc/steps/components/common/menu/private/IncChangeButton.vue";
import IncPrintButton  from "@/modules/inc/steps/components/common/menu/private/IncPrintButton.vue";

export default {
    name: "IncSideMenu",
    props: {
        sites: {
            required: true,
        },

        incident: {
            required: true,
            type    : Object,
        },

        clipboardEntry: {

        },

        index: {

        }
    },

    data: () => ({
        showMenu: false
    }),

    components: {
        IncPrintButton,
        IncChangeButton,
        IncCreateButton,
        CMenuButton
    },

    computed: {
        permanent () {
            return this.preferences["permanentMenu"];
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        isClipboardAllowed () {
            if (!this.incident || this.incident.deleted) {
                return false;
            }

            const unit = this.$store.getters.site;
            if (!unit) {
                return false;
            }

            let terminated = true;
            this.incident.data.forEach(step => {
                if (step.visible) {
                    const entry = step.collection.find(entry => entry.unit.id === unit.id);
                    if (entry) {
                        if (entry.status.type !== 'T') {
                            terminated = false;
                        }
                    }
                }
            })

            if (terminated) {
                return false;
            }

            return this.incident.category === "assessment" || this.incident.category === "incident" || this.incident.category === "repair";
        },

        isClipboardRemoveAllowed () {
            if (!this.incident || this.incident.deleted) {
                return false;
            }

            const unit = this.$store.getters.site;
            if (!unit) {
                return false;
            }

            return this.incident.category === "assessment" || this.incident.category === "incident" || this.incident.category === "repair";
        },

        type () {
            return this.$store.getters.incidenttypes.find (type => this.incident.typeId === type.id);
        },

        allowed () {
            return this.type["allowedSwitches"];
        },
    },

    methods: {
        onSave () {
            this.$emit("save");
        },

        onHistory () {
            this.$emit("history");
        },

        onRefresh () {
            this.$emit("refresh");
        },

        onClipboard () {
            Core.message.confirm(
                this,
                this.$t("clipboard.add.query"),
                this.$t("clipboard.add.text"),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    this.$emit("clipboard");
                }
            );
        },

        onClipboarRemove () {
            Core.message.confirm(
                this,
                this.$t("clipboard.remove.query"),
                this.$t("clipboard.remove.text"),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    this.$emit("clipboardremove", this.clipboardEntry);
                }
            );
        },

        onDelete () {
            Core.message.confirm(
                this,
                this.$t("inc.delete.confirm.query"),
                this.$t("inc.delete.confirm.text"),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    this.$emit("delete");
                }
            );
        },

        onUnDelete () {
            Core.message.confirm(
                this,
                this.$t("inc.undelete.confirm.query"),
                this.$t("inc.undelete.confirm.text"),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    this.$emit("undelete");
                }
            );
        },

        onSubmenuOpen (open) {
            this.showMenu = open;
        },

        onMail () {
            this.$emit("email");
        },

        onChanged () {
            this.$emit("typechanged");
        }
    }
}
</script>

<style scoped>
.menu-top-space {
    padding-top: 73px;
}
</style>
